import { invokeAuthed } from './functionAuth';

const FALLBACK = 'AI is unavailable right now. Your Moments are not affected.';
const NOT_DEPLOYED = 'The Moments AI service has not been deployed to this project yet. Your Moments are not affected.';

const call = async (body) => {
  const { data, error } = await invokeAuthed('moments-ai', body);
  if (error) {
    let message = FALLBACK;
    let code = 'unavailable';
    if (error.context?.status === 404) {
      message = NOT_DEPLOYED;
      code = 'not_deployed';
    }
    try {
      const payload = await error.context.json();
      if (payload?.error) message = payload.error;
      if (payload?.code && code !== 'not_deployed') code = payload.code;
    } catch (e) {
      // Network or non-JSON failure: keep the message chosen above.
    }
    if (message === FALLBACK && error.context?.status) {
      message = `${FALLBACK} (HTTP ${error.context.status}${code !== 'unavailable' ? `, ${code}` : ''})`;
    }
    const err = new Error(message);
    err.code = code;
    throw err;
  }
  if (!data || data.error) throw new Error(data?.error || FALLBACK);
  return data;
};

// Every call is made only when the user clicks a button. Nothing runs in the background.
export const aiService = {
  analyseMoment: (momentId, task) => call({ mode: 'moment', momentId, task }),
  relationshipInsights: (contactId) => call({ mode: 'relationship', contactId }),
  reflect: (startDate, endDate) =>
    call({ mode: 'reflection', startDate: startDate.toISOString(), endDate: endDate.toISOString() })
};